import { useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CartIcon } from "@shopify/polaris-icons";
import { Icon } from "@shopify/polaris";
import { useAppDispatch, useAppSelector } from "hooks";
import { RootState } from "configureStore";
import HeaderBadge from "components/header-badge/header-badge";
import { TOPBAR_ICON_BUTTON_TOUCH_TARGET } from "components/layout/topbar-icon-button";
import {
  fetchCartThunk,
  openCartDrawer,
  clearBadgePulse,
  resetCartState,
} from "./documentCart.slice";
import "./document-cart.scss";

const CartBadge: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { companyId } = useParams<{ companyId: string }>();
  const { count, badgePulse, companyId: cartCompanyId } = useAppSelector(
    (state: RootState) => state.documentCartReducer
  );

  useEffect(() => {
    if (!companyId) {
      dispatch(resetCartState());
      return;
    }
    if (cartCompanyId && cartCompanyId !== companyId) {
      dispatch(resetCartState());
    }
    dispatch(fetchCartThunk(companyId));
  }, [companyId, dispatch]);

  useEffect(() => {
    if (!badgePulse) return;
    const timer = window.setTimeout(() => dispatch(clearBadgePulse()), 220);
    return () => window.clearTimeout(timer);
  }, [badgePulse, dispatch]);

  const handleClick = useCallback(() => {
    dispatch(openCartDrawer());
  }, [dispatch]);

  if (!companyId) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`document-cart-badge relative p-2 border-none bg-transparent hover:bg-gray-100 rounded-sm transition-colors focus:outline-none [&_.Polaris-Icon_svg]:text-gray-600 ${TOPBAR_ICON_BUTTON_TOUCH_TARGET} ${
        badgePulse ? "document-cart-badge--pulse" : ""
      }`}
      aria-label={t("document_cart")}
      title={t("document_cart")}
    >
      <Icon source={CartIcon as any} tone="base" />
      <HeaderBadge count={count} tone="blue" />
    </button>
  );
};

export default CartBadge;
